import {CementClassificationInputNames, MaterialType} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

import {LONG_COLUMN_WIDTH, SHORT_COLUMN_WIDTH} from '@settings/modules/common/consts'

const cementFields = [
  {key: CementClassificationInputNames.Standard, minWidth: LONG_COLUMN_WIDTH},
  {key: CementClassificationInputNames.Type, minWidth: LONG_COLUMN_WIDTH},
  {key: CementClassificationInputNames.Const1, minWidth: SHORT_COLUMN_WIDTH},
  {key: CementClassificationInputNames.Const2, minWidth: SHORT_COLUMN_WIDTH},
  {key: CementClassificationInputNames.Strength1, minWidth: SHORT_COLUMN_WIDTH},
  {key: CementClassificationInputNames.Strength2, minWidth: SHORT_COLUMN_WIDTH},
  {key: CementClassificationInputNames.SulphateResistance},
  {key: CementClassificationInputNames.SulphurLevel},
  {key: CementClassificationInputNames.HeatOfHydration},
  {key: CementClassificationInputNames.LowAlkali},
  {key: CementClassificationInputNames.SpecialCharacteristics},
  {key: CementClassificationInputNames.IntermediateMillProduct},
  {key: CementClassificationInputNames.CategoryForAnnualReport, minWidth: LONG_COLUMN_WIDTH},
  {key: CementClassificationInputNames.ReferenceMeshSizeForResidue, minWidth: LONG_COLUMN_WIDTH}
]

export const CementClassificationHeader = () => {
  return <ClassificationHeaderCells fields={cementFields} materialType={MaterialType.Cement} />
}
